import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './WhyHowWhat.css';

export default class WhyHowWhat extends Component {
  static propTypes = {
    lines: PropTypes.array,
  }

  render() {
    const { lines } = this.props;

    return (
      <section className="why-how-what">
        <p dangerouslySetInnerHTML={{ __html: lines[0] }} />
        <p dangerouslySetInnerHTML={{ __html: lines[1] }} />
      </section>
    );
  }
}
